import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Singleproject(props) {
  const gradientStyle = {
    background: "linear-gradient(90deg, #0970C1 70%, rgb(255, 255, 255) 70%)",
  };
  const ColorStyle = {
    color: "#fff",
  };
  const textAndBackgroundColor = {
    backgroundColor: "#F47A1F",
  };
  return (
    <div className="singleproject p-100" style={gradientStyle}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="img_logo">
              <StaticImage
                src="../../../images/location_new/singlecase/game-logo-4.webp"
                alt="LogoNext"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={220}
                height={100}
              />
            </div>
            <div className="example" data-text="Feature">
              <h2 style={ColorStyle}>
                Parcheesi Cash: An online multiplayer Spanish board game
              </h2>
            </div>
            <p style={ColorStyle}>
              Parcheesi Cash is an online multiplayer Spanish board game that is
              a recreation of the Parcheesi – the national game of India since
              medieval times. It’s an interactive game where users can team up
              with friends or family or compete against the AI.
            </p>
            <Link
              to={`/case-studies/parcheesi`}
              className="case_btn"
              aria-label="TekRevol Contact"
              style={textAndBackgroundColor}
            >
              View Case Study {Case_Arrow}
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="technology_list">
              <div className="tech_name">Web Game</div>
              <div className="tech_name">App Game</div>
              <div className="tech_name">UI UX Design</div>
            </div>
            <div className="mx-img">
              <StaticImage
                src="../../../images/location_new/singlecase/game-img.webp"
                alt="CaseImg"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={909}
                height={607}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Singleproject;
